import useEvent from "react-use-event-hook";

import {
  Api,
  createErrorResult,
  createSuccessResult,
  errors,
  getCompanyId,
  getWalkingDirectionsPath,
  ICoordinate,
  IWalkingDirectionsResponse,
  IWarkDistanceAndTime,
  Log,
  SECONDS_IN_MINUTE,
  SimpleResult,
  TLatLngExpression,
} from "@ryde/shared";

export const useRoutingServices = () => {
  const getWalkingDistanceAndTime = useEvent(
    async ({
      origin,
      destination,
    }: {
      origin: ICoordinate;
      destination: ICoordinate;
    }): Promise<SimpleResult<IWarkDistanceAndTime>> => {
      const companyId = getCompanyId();
      if (!companyId) {
        return createErrorResult(
          errors.map.getWalkingDistanceAndTime,
          "Missing companyId for walking directions",
        );
      }

      try {
        const response = await Api.post<
          SimpleResult<IWalkingDirectionsResponse>
        >(getWalkingDirectionsPath(companyId), { origin, destination });

        const result = response?.data;
        if (!result?.success || !result.data) {
          return createErrorResult(
            errors.map.getWalkingDistanceAndTime,
            "No walking route found between the given points",
          );
        }

        const { distance, duration: durationInSeconds, path } = result.data;
        const minutes = Math.floor(durationInSeconds / SECONDS_IN_MINUTE);
        const seconds = durationInSeconds % SECONDS_IN_MINUTE;

        return createSuccessResult({
          distance,
          duration: { minutes, seconds },
          path: (path ?? []).map(p => [p.lat, p.lng]) as TLatLngExpression[],
        });
      } catch (err) {
        Log.warn("Exception while calculating walking distance and time", err);
        return createErrorResult(
          errors.map.getWalkingDistanceAndTime,
          "Exception while calculating walking distance and time",
        );
      }
    },
  );

  return {
    getWalkingDistanceAndTime,
  };
};
